/**
 * Always renders a `<button>` or an `<a>`, both of which take padding, border,
 * background and sizing directly. A wrapper div would add an element that does
 * nothing, and would put the column's background behind the button rather than
 * on it. No configuration changes that.
 */
export const resolveNoContainer = (): boolean => false;
